import type { Room } from "@workspace/livekit/client"
import type { event } from "@rrweb/types"

const CHUNK_SIZE = 15000

// Per-room send queue. Serializing outbound byte streams ensures rrweb events
// arrive on the receiver in emit order; otherwise concurrent streams can
// complete out of order and mutations get applied against a stale DOM.
const sendQueues = new WeakMap<Room, Promise<void>>()

async function writeOne(room: Room, event: event) {
  const encoder = new TextEncoder()
  const payload = JSON.stringify(event)
  const data = encoder.encode(payload)

  const writer = await room.localParticipant.streamBytes({
    topic: "replay:event",
  })

  for (let i = 0; i < data.length; i += CHUNK_SIZE) {
    const chunk = data.slice(i, i + CHUNK_SIZE)
    await writer.write(chunk)
  }

  await writer.close()
}

export function streamEvent(room: Room, event: event) {
  if (room.state !== "connected") return

  const prev = sendQueues.get(room) ?? Promise.resolve()
  const next = prev
    .then(() => writeOne(room, event))
    .catch((error) => {
      console.error("Error streaming event:", error)
    })
  sendQueues.set(room, next)
}
